import mixpanel from "mixpanel-browser";
import React, { useState } from "react";
import Loader from "../../../component/loader";
import { useCreatePageMutation } from "../../../redux/slices/pageSlice";
import "./styles.css";
import Fail from "./Fail";
import Success from "./Success";
import "./styles.css";
import { useAppContext } from './../../../util'

export default function Form({
  open,
  onClose,
  email,
  formButtonText,
  formConfirmationText,
  messageVisibility,
  nameVisibility,
  phoneVisibility,
  emailVisibility,
}) {

  const { userId, pageId } = useAppContext()

  if (!open) return null;

  const [createPage, { isLoading, isError, isSuccess }] =
    useCreatePageMutation();
  const [formData, setFormData] = useState({
    name: "",
    userEmail: "",
    phone: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    const newErrors = {};
    if (nameVisibility && !formData.name) newErrors.name = "Required";
    if (emailVisibility && !formData.userEmail)
      newErrors.userEmail = "Required";
    if (phoneVisibility && !formData.phone) newErrors.phone = "Required";
    if (messageVisibility && !formData.message) newErrors.message = "Required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      const response = await createPage({
        ...formData,
        sendToEmail: email,
      }).unwrap();
      if (response.success) {
        mixpanel.track(
          "Web Contact Form Submitted", 
          {
            distinct_id: userId,
            stack_id: pageId,
          }
        );
        setSuccess(response);
      }
    } catch (error) {
      setErrors({ form: "Failed to submit the form. Please try again." });
    }
  };

  return (
    <>
      <div className="modal-overlay" />
      <div className="modal-container">
        <div className="modal-header">
          <span
            className="back-button"
            onClick={() => {
              setSuccess(null);
              onClose();
            }}
          >
            <i
              className="fa-sharp fa-solid fa-arrow-left"
              style={{ fontSize: "20px", fontWeight: 900, color: "#181052" }}
            />
          </span>
          <span className="modal-title">Contact</span>
          <div className="right-placeholder"></div>
        </div>

        <div className="form-container">
          {success === null && !isLoading && (
            <form onSubmit={handleSubmit}>
              {nameVisibility && (
                <div className="input-container">
                  <div className={`input-group ${errors.name ? "error" : ""}`}>
                    <span className="input-icon">
                      <i className="fa-sharp fa-solid fa-circle-user"></i>
                    </span>
                    <input
                      type="text"
                      name="name"
                      placeholder="Name"
                      className={`form-input ${errors.phone ? "error" : ""}`}
                      onChange={handleChange}
                      value={formData.name}
                    />
                  </div>

                  <div className="error-message">{errors.name}</div>
                </div>
              )}
              {emailVisibility && (
                <div className="input-container">
                  <div
                    className={`input-group ${errors.userEmail ? "error" : ""}`}
                  >
                    <span className="input-icon">
                      <i className="fa-sharp fa-solid fa-envelope"></i>
                    </span>
                    <input
                      type="email"
                      name="userEmail"
                      placeholder="Email"
                      className={`form-input ${
                        errors.userEmail ? "error" : ""
                      }`}
                      onChange={handleChange}
                      value={formData.userEmail}
                    />
                  </div>
                  <div className="error-message">{errors.userEmail}</div>
                </div>
              )}
              {phoneVisibility && (
                <div className="input-container">
                  <div className={`input-group ${errors.phone ? "error" : ""}`}>
                    <span className="input-icon">
                      <i className="fa-sharp fa-solid fa-phone"></i>
                    </span>

                    <input
                      type="text"
                      name="phone"
                      placeholder="Phone"
                      className={`form-input ${errors.phone ? "error" : ""}`}
                      onChange={handleChange}
                      value={formData.phone}
                    />
                  </div>

                  <div className="error-message">{errors.phone}</div>
                </div>
              )}
              {messageVisibility && (
                <div className="input-textarea-container">
                  <div
                    className={`textarea-container ${
                      errors.message ? "error" : ""
                    }`}
                  >
                    <textarea
                      rows={5}
                      name="message"
                      type="text"
                      placeholder="Message"
                      className={`form-input ${errors.message ? "error" : ""}`}
                      onChange={handleChange}
                      value={formData.message}
                      maxLength={500}
                    />
                  </div>
                  <div className="textarea-count">
                    {formData.message.length}/500
                  </div>

                  <div className="error-message">{errors.message}</div>
                </div>
              )}
              {errors.form && (
                <div className="error-message">{errors.form}</div>
              )}

              <button className="submit-button" type="submit">
                <div
                  style={{
                    gap: "1rem",
                    display: "flex",
                    alignItems: "center",
                    padding: "10px",
                  }}
                >
                  <p className="submit-button-text">{formButtonText}</p>
                </div>
              </button>
            </form>
          )}
          {isLoading && (
            <div className="loader-container">
              <Loader width={"50px"} />
            </div>
          )}
          {isError && <Fail />}
          {isSuccess && <Success formConfirmationText={formConfirmationText} />}
        </div>
      </div>
    </>
  );
}
